import { render, staticRenderFns } from "./WithHeroImage.vue?vue&type=template&id=b442e074&"
import script from "./WithHeroImage.vue?vue&type=script&lang=js&"
export * from "./WithHeroImage.vue?vue&type=script&lang=js&"
import style0 from "./WithHeroImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports